import uuid from 'uuid'
import mergeDeepRight from 'ramda/src/mergeDeepRight'

const defaultSettings = {
  _id: uuid.v4(),
  favoriteModels: [],
  recentModels: [],
  favoriteDoorControllerModels: [],
  recentDoorControllerModels: [],
  type: 'settings',
  userSettings: {
    ppfZoneBorders: [328, 328, 164, 32],
    ppfZoneColors: ['blue', 'blue', 'blue', 'blue'],
    ppfZoneColorOverride: false
  }
}

export const addDefaultSettings = mergeDeepRight(defaultSettings)
export default defaultSettings



// WEBPACK FOOTER //
// ./src/helpers/defaultSettings.js